import React from 'react';
import classNames from 'classnames';

import styles from '../TaskActions.module.scss';

interface Props {
    showIf?: boolean;
    modifiers?: TaskActionsRowModifiers[];
    children: React.ReactNode | React.ReactNode[];
}

export enum TaskActionsRowModifiers {
    // @ts-ignore
    SpaceBetween = styles.spaceBetween,
    // @ts-ignore
    WithoutSpacing = styles.withoutSpacing,
}

export function TaskActionsRow({ showIf = true, children, modifiers = [] }: Props): React.ReactElement<any> | null {
    return showIf ? <div className={classNames([styles.actions, ...modifiers])}>{children}</div> : null;
}
